/** @format */
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from 'sis-common';

@Component({
    selector: 'sis-top-navigation-icons',
    templateUrl: './top-navigation-icons.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TopNavigationIconsComponent {
    @Input() mobileMode: boolean;
    @Input() frontendName: string;
    @Input() initialFocus: boolean = false;
    @Input() navCollapsed: boolean;

    @Output() blurMobileMenuIcons = new EventEmitter<any>();
    @Output() keydownPressed = new EventEmitter<any>();

    readonly authenticated = toSignal(inject(AuthService).userLoggedIn$);
}
